import PageHero from "@/components/common/PageHero";
import FinalCTA from "@/components/sections/FinalCTA";
import WhyChoose from "@/components/sections/WhyChoose";
import { Globe2, Users, Award, Rocket } from "lucide-react";

const stats = [
  { Icon: Globe2, v: "5+", l: "Continents" },
  { Icon: Users, v: "120+", l: "Brands Scaled" },
  { Icon: Award, v: "$240M+", l: "Revenue Driven" },
  { Icon: Rocket, v: "8 Yrs", l: "Of Compounding" },
];

export default function AboutPage() {
  return (
    <main data-testid="about-page">
      <PageHero
        eyebrow="About Kavion"
        title={<>A Hong Kong agency<br /><span className="text-gradient">obsessed with scale.</span></>}
        subtitle="Kavion Global Limited is a premium eCommerce growth partner for ambitious D2C brands. We sit at the intersection of design, data, and paid media."
      />

      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="aspect-[4/3] rounded-3xl overflow-hidden border border-white/10">
            <img
              src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&w=1200&q=80"
              alt="Premium modern office in Hong Kong"
              className="h-full w-full object-cover"
            />
          </div>
          <div>
            <span className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">Our Story</span>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold text-white tracking-tight leading-[1.05]">
              Built in Hong Kong.<br />Trusted globally.
            </h2>
            <p className="mt-5 text-zinc-400 leading-relaxed">
              From our office at 29/F Universal Trade Centre in Central, Hong Kong, we operate
              as a full-service growth partner for D2C brands across the US, UK, Europe, UAE,
              and Australia. We don't pitch decks. We ship outcomes.
            </p>
            <p className="mt-4 text-zinc-400 leading-relaxed">
              Our team is a tight-knit unit of designers, developers, performance marketers, and
              CRO strategists — each obsessed with one question: how do we make this brand more
              profitable, this month?
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.l} className="glass rounded-2xl p-5">
                  <s.Icon className="h-5 w-5 text-blue-300" />
                  <div className="font-display text-3xl font-extrabold text-white mt-3">{s.v}</div>
                  <div className="text-xs text-zinc-500 uppercase tracking-wider mt-1">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <WhyChoose />
      <FinalCTA />
    </main>
  );
}
